import { BlastEvent, SimulationConfig } from '@/types';
import { drawBlastShape } from '@/logic/break/BreakUtils';
import { registerBlastAnimation } from './BlastAnimationRegistry';

export const PhantomRingsAnimation = (
  ctx: CanvasRenderingContext2D,
  e: BlastEvent,
  config: SimulationConfig,
  progress: number
) => {
  for(let i=0; i<5; i++){
    const p = (progress + i * 0.1) % 1;
    drawBlastShape(ctx, e, e.maxRadius + p * 200);
    ctx.globalAlpha = (1-p) * 0.6; ctx.lineWidth = 10 * (1-p); ctx.stroke();
  }
};

registerBlastAnimation('PHANTOM_RINGS', PhantomRingsAnimation);
